module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bg-gray"
  }, [_c('banner-bg', {
    attrs: {
      "title": "组织结构",
      "subtitle": "相信团队的力量",
      "src": require('@/assets/images/mainindex/organization-banner@2x.png')
    }
  }), _vm._v(" "), (_vm.activeName === '全国') ? _c('div', {
    staticClass: "container-content container-wrap",
    domProps: {
      "innerHTML": _vm._s(_vm.articleRow.data.content)
    }
  }) : _c('div', {
    staticClass: "organization_content"
  }, [_c('div', {
    staticClass: "header_screen container-wrap"
  }, [_c('div', {
    staticClass: "header_screen_item"
  }, [_c('div', {
    staticClass: "header_screen_item_title"
  }, [_vm._v("省份：")]), _vm._v(" "), _c('div', {
    staticClass: "header_screen_item_content"
  }, _vm._l((_vm.areaList), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index > 0),
        expression: "index>0"
      }],
      key: index,
      staticClass: "header_screen_item_el",
      class: _vm.params.weiyuanhui_id == item.id ? 'header_screen_item_el_active' : 0,
      on: {
        "click": function($event) {
          return _vm.onSelectArea(item.id)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.province) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "header_screen_item"
  }, [_c('div', {
    staticClass: "header_screen_item_title"
  }, [_vm._v("类型：")]), _vm._v(" "), _c('div', {
    staticClass: "header_screen_item_content"
  }, _vm._l((_vm.typeData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "header_screen_item_el",
      class: _vm.params.area_type == item.key ? 'header_screen_item_el_active' : 0,
      on: {
        "click": function($event) {
          return _vm.onSelectType(item.key)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "header_screen_item"
  })]), _vm._v(" "), _c('div', {
    staticClass: "organization_content_list container-wrap"
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "organization_content_list_item"
    }, [_c('div', {
      staticClass: "organization_content_list_item_left"
    }, [_c('el-image', {
      attrs: {
        "src": item.wechat_pic_url,
        "preview-src-list": [item.wechat_pic_url]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_tip"
    }, [_vm._v("加我企业微信")])], 1), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc"
    }, [_c('div', {
      staticClass: "organization_content_list_item_desc_tip"
    }, [_vm._v("全国跳绳推广委员会")]), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc_title"
    }, [_vm._v("\n              " + _vm._s(item.area_type == 1 ? item.province : item.city) + "推广负责人\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc_contacts"
    }, [_vm._v("\n              姓名     " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc_contacts"
    }, [_vm._v("\n              电话     " + _vm._s(item.phone) + "\n            ")])]), _vm._v(" "), (item.area_type == 1) ? _c('div', {
      staticClass: "organization_content_list_item_tag_province"
    }, [_vm._v("省级")]) : _c('div', {
      staticClass: "organization_content_list_item_tag"
    }, [_vm._v("市级")])])
  }), _vm._v(" "), (_vm.row.totalpage > 1) ? _c('el-pagination', {
    staticStyle: {
      "padding-bottom": "20px"
    },
    attrs: {
      "current-page": _vm.row.p,
      "page-size": _vm.row.step,
      "background": "",
      "layout": "total, prev, pager, next",
      "total": _vm.row.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.row, "p", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.row, "p", $event)
      }
    }
  }) : _vm._e()], 2)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a191ced","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/Organization.vue
// module id = 1360
// module chunks = 0